<template lang="pug">
    slick(v-if='context == "esreps"', ref='slick', :options='slickOptions')
        //- .esreps-main.slide1(:class="'context-'+context", v-show="subtitle && button")
        //-     h1(v-html="title")
        //-     h1.mobile {{titleMobile}}
        //-     h2 {{subtitle}}
        //-     div.btn-register-wrapper
        //-       span.btn-register
        //-         router-link(:to="{name: 'ContentCategory', params: {slug: 'recursos-covid-19', childSlug: 'informacion-de-antecedentes-covid-19'}}")
        //-           span.link-button {{button}}
        .esreps-main.slide2(:class="'context-'+context", v-show="subtitle && button")
            //- h1 MÁS DE 12.000
            //- h1.mobile MÁS DE 12.000
            //- h1 ENTRENADORES REGISTRADOS
            //- h1.mobile ENTRENADORES REGISTRADOS
            h2 Apoyamos y profesionalizamos a la comunidad del ejercicio físico
            //- h2 Apoyamos y profesionalizamos a entrenadores personales, técnicos de sala, monitores deportivos…
            div.btn-register-wrapper
              router-link(:to="{name: 'ContentEntry', params: {slug: 'sobre-nosotros'}}")
                span.btn-register
                  span.link-button Sobre nosotros
              router-link(:to="{name: 'ContentEntry', params: {slug: 'que-hacemos'}}")
                span.btn-register
                  span.link-button Qué hacemos
              router-link(:to="{name:'RegisterSection', params: {type: 'profesional'}}")
                span.btn-register
                  span.link-button Únete al registro
        //- .esreps-main.slide3(:class="'context-'+context", v-show="subtitle && button")
        //-     h1.bolder 12.000
        //-     h1.mobile.bolder 12.000
        //-     h1 ENTRENADORES REGISTRADOS
        //-     h1.mobile ENTRENADORES REGISTRADOS
        //-     h2 Apoyamos y profesionalizamos a entrenadores personales, técnicos de sala, monitores deportivos…
        //-     div.btn-register-wrapper
        //-       span.btn-register
        //-         router-link(:to="{name:'RegisterSection', params: {type: 'profesional'}}")
        //-           span.link-button Quiero registrarme
        //- .esreps-main.slide4(:class="'context-'+context", v-show="subtitle && button")
        //-     h1 Tu instalación hacia el camino correcto
        //-     h1.mobile Tu instalación hacia el camino correcto
        //-     h2 Todas las herramientas, recursos, conexiones y respuestas que necesitas para gestionar con éxito tu instalación deportiva
        //-     div.btn-register-wrapper
        //-       span.btn-register
        //-         router-link(:to="{name: 'ContentCategory', params: {slug: 'beneficios', childSlug: 'beneficios-para-instalaciones'}}")
        //-           span.link-button Beneficios
    
    slick(v-else-if='context == "colreps"', ref='slick', :options='slickOptions')
        .esreps-main.slide2(:class="'context-'+context", v-show="subtitle && button")
            h1 ASOCIACIÓN COLOMBIANA DE FITNESS
            h1.mobile ASOCIACIÓN COLOMBIANA DE FITNESS
            h2 Da soporte a la industria del fitness para que más colombianos cuenten con servicios de salud y ejercicio físico de calidad
            div.btn-register-wrapper
              span.btn-register
                router-link(:to="{name: 'ContentCategory', params: {slug: 'sobre-nosotros', childSlug: 'contacto'}}")
                  span.link-button Contáctanos
        .esreps-main.slide3(:class="'context-'+context", v-show="subtitle && button")
            h1 SOMOS MÁS DE 300
            h1.mobile SOMOS MÁS DE 300
            h1 ENTRENADORES REGISTRADOS
            h1.mobile ENTRENADORES REGISTRADOS
            h2 Apoyamos y profesionalizamos a entrenadores personales, técnicos de sala, monitores deportivos…
            div.btn-register-wrapper
              span.btn-register
                router-link(:to="{name:'RegisterSection', params: {type: 'profesional'}}")
                  span.link-button Quiero registrarme

    slick(v-else-if='context == "mexreps"', ref='slick', :options='slickOptions')
        .esreps-main.slide2(:class="'context-'+context", v-show="subtitle && button")
            h1 ASOCIACIÓN MEXICANA DE FITNESS
            h1.mobile ASOCIACIÓN MEXICANA DE FITNESS
            h2 Da soporte a la industria del fitness para que más mexicanos cuenten con servicios de salud y ejercicio físico de calidad
            div.btn-register-wrapper
              span.btn-register
                router-link(:to="{name: 'ContentCategory', params: {slug: 'sobre-nosotros', childSlug: 'contacto'}}")
                  span.link-button Contáctanos
        .esreps-main.slide3(:class="'context-'+context", v-show="subtitle && button")
            h1 SOMOS MÁS DE 300
            h1.mobile SOMOS MÁS DE 300
            h1 ENTRENADORES REGISTRADOS
            h1.mobile ENTRENADORES REGISTRADOS
            h2 Apoyamos y profesionalizamos a entrenadores personales, técnicos de sala, monitores deportivos…
            div.btn-register-wrapper
              span.btn-register
                router-link(:to="{name:'RegisterSection', params: {type: 'profesional'}}")
                  span.link-button Quiero registrarme

</template>

<script>
import Api from './services/Api'
import { mapState } from 'vuex'
import Slick from 'vue-slick'

const messageMap = {
  esreps: {
    title: 'Juntos somos más fuertes',
    titleMobile: 'Juntos somos más fuertes',
    subtitle:
      'La Federación Española de Fitness está trabajando para ofrecer apoyo a todo el sector durante la pandemia del Coronavirus',
    button: 'Descargar recursos Covid',
  },
  colreps: {
    title: 'Somos más de 12.000 miembros<br>en la federación',
    titleMobile: 'Somos más de 12.000 miembros en la federación',
    subtitle: 'Desde 2011 apoyando a todos los profesionales',
    button: 'Hazte miembro',
  },
}

export default {
  name: 'HomeSlide',
  computed: mapState(['context']),
  components: { Slick },
  data() {
    return {
      title: null,
      titleMobile: null,
      subtitle: null,
      button: null,
      slickOptions: {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true,
        accessibility: true,
        arrows: false,
        dots: true,
        draggable: true,
        swipe: true,
      },
    }
  },
  created() {
    this.title = messageMap[this.context].title
    this.titleMobile = messageMap[this.context].titleMobile
    this.subtitle = messageMap[this.context].subtitle
    this.button = messageMap[this.context].button
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
@import './../variables_colreps';
@import './../variables_mexreps';

@import 'HomeSlide';

.context-colreps {
  @import 'HomeSlideColreps';
}

.context-mexreps {
  @import 'HomeSlideMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/HomeSlide.vue